module.exports = __webpack_public_path__ + "img/notification.e6b66597.svg";